import { PhysicalLocationID } from '../api-clients/_api';

const NUMBER_OF_RELAYS = 8;
export const relays = Array.from({ length: NUMBER_OF_RELAYS }, (_, i) => i + 1);

export const TOTAL_MODBUS_ADDRESSES = 31;
export const TOTAL_MODBUS_CHANNELS = 4;

export const modbusAddresses = Array.from({ length: TOTAL_MODBUS_ADDRESSES }, (_, i) => i + 1);
export const modbusChannels = Array.from({ length: TOTAL_MODBUS_CHANNELS }, (_, i) => `C${i + 1}`);
export const modbusChannelDescription = {
  C1: 'Comm 1',
  C2: 'Comm 2',
  C3: 'Comm 3',
  C4: 'Comm 4',
};

export const MAX_ZONES_ALLOWED = 4;

export const TOTAL_CLAMPS = 3;

export const DEFAULT_SENSOR_LOCATION = PhysicalLocationID.LIVING_ROOM;

// This file can contain helper methods and be the single source of truth for configuration values
// that will eventually be in here when the API's have been created to get specific
// configuration values for hardware.
